<template>
<div class="button icon level-item kb-header-button"
     :title="title"
     @click="showFileManagementModal"
>
    <i class="far fa-hdd"></i>
</div>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "BaseFileManagementButton",
    props: {
        title: String,
    },
    methods: {
        ...mapActions('fileManagement', ['showFileManagementModal']),
    }
}
</script>
